module.exports = __webpack_public_path__ + "static/media/field-project-management.c3d1651e.svg";